import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import MarqueeStrip from "../components/MarqueeStrip";
import CRMHighlight from "../components/CRMHighlight";
import Services from "../components/Services";
import Process from "../components/Process";
import WhyChooseUs from "../components/WhyChooseUs";
import Compliance from "../components/Compliance";
import CTA from "../components/CTA";

export default function HomePage() {
  return (
    <>
      <Hero />
      <CRMHighlight />
      <div id="funded-form" className="scroll-mt-28" aria-hidden="true" />
      <Services />
      <MarqueeStrip />
      <About />
      <Process />
      <WhyChooseUs />
      <Compliance />
      <CTA />
    </>
  );
}
